import { FormikProps } from "formik";
import CustomTextArea from "../../../../../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../../../../../components/Flex";
import useDisclosure from "../../../../../../../../../../../hooks/use-disclosure";
import { StyleAddButton } from "../../../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import { Form2Payload } from "../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import { AddIcdCodes, renderSelectedIcdCodes } from "../Add-ICD-Codes";

interface ProgressNoteDiagnosisProps {
  formik: FormikProps<Form2Payload>;
}

/**
 * Primary Diagnosis section — the same "Add ICD Codes" button, picker and
 * selected-codes list every other note type uses, writing to the shared
 * `assessmentCodes` key. Only the justification free text is Progress Note
 * specific.
 */
const ProgressNoteDiagnosis = ({ formik }: ProgressNoteDiagnosisProps) => {
  const icdDisclosure = useDisclosure();

  return (
    <Flex flexDirection="column" gap={1} width="100%">
      <StyleAddButton
        w="120px"
        onClick={() => icdDisclosure.open()}
        label="Add ICD Codes"
      />
      <AddIcdCodes formik={formik} disclosureHost={icdDisclosure} />

      {!!formik.values?.assessmentCodes?.length && (
        <Flex flexDirection={"column"} width={"100%"} gap={1}>
          {renderSelectedIcdCodes(
            formik.values?.assessmentCodes ?? [],
            (code) => {
              formik.setFieldValue("assessmentCodes", [
                ...(formik.values?.assessmentCodes ?? []).filter(
                  (it) => it.value !== code.value
                ),
              ]);
            },
            "20vh"
          )}
        </Flex>
      )}

      <CustomTextArea
        label="Diagnosis Justification"
        rows={3}
        name="diagnosisJustification"
        placeholder="supporting evidence for diagnosis, such as assessment measures, differential diagnosis, etc."
        onBlur={formik.handleBlur}
        value={formik.values?.diagnosisJustification || ""}
        onChange={formik.handleChange}
      />
    </Flex>
  );
};

export default ProgressNoteDiagnosis;
